export interface LoginUuidModelInterface {
  uuid: string;
  isFirstLoad: boolean;
}

export class LoginUuidModel implements LoginUuidModelInterface {
  public uuid: string;
  public isFirstLoad: boolean;

  constructor(uuid: string, isFirstLoad: boolean) {
    this.uuid = uuid;
    this.isFirstLoad = isFirstLoad;
  }
}
